import './shared';
import './modules/front';
import React from 'react';
import ReactDOM from 'react-dom/client';
import ItemDatePicker from './modules/front/ItemDatePicker';
import './forms/make-form-persistent';
import './forms/prevent-form-double-click';
import OrderItemPackageButton from './modules/front/OrderItemPackageButton';
import './cookies/consent';
import './forms/make-form-persistent';

// Bootstrap
import './modules/front/scss/main.scss'
import ReservationExternal from "@/modules/front/ReservationExternal/ReservationExternal";
import AiAssistant from "@/ai-chat/AiAssistant";
//import 'bootstrap/scss/bootstrap.scss';


// Webpack HMR

if (module.hot) {
	module.hot.accept();
}

document.addEventListener('DOMContentLoaded', () => {

	const e = React.createElement;
	const domContainer = document.querySelectorAll('.item_date_picker_container');

	for (let i = 0; i < domContainer.length; i++) {
		const root = ReactDOM.createRoot(domContainer[i]);
		root.render(React.createElement(ItemDatePicker, {
			'locale': domContainer[i].getAttribute('data-locale'),
			'seasonId': domContainer[i].getAttribute('data-season-id'),
			'offices': JSON.parse(domContainer[i].getAttribute('data-offices')),
			'office': domContainer[i].getAttribute('data-office'),
			'lockOffice': domContainer[i].getAttribute('data-lock-office'),
			'variants': JSON.parse(domContainer[i].getAttribute('data-variants') || '[]'),
			'itemId': domContainer[i].getAttribute('data-item-id'),
			'from': domContainer[i].getAttribute('data-from'),
			'to': domContainer[i].getAttribute('data-to'),
			'showModal': domContainer[i].getAttribute('data-show-modal'),
			'weekendRentalNotice': domContainer[i].getAttribute('data-weekend-rental-notice'),
		}));

	}

	const orderItemPackageButton = document.querySelectorAll('.component-order-item-package-button');
	for (let i = 0; i < orderItemPackageButton.length; i++) {
		const root = ReactDOM.createRoot(orderItemPackageButton[i]);
		root.render(React.createElement(OrderItemPackageButton, {
			'locale': orderItemPackageButton[i].getAttribute('data-locale'),
			'packageId': orderItemPackageButton[i].getAttribute('data-package-id'),
			'lengthHours' : orderItemPackageButton[i].getAttribute('data-length-hours'),
			'offices': JSON.parse(orderItemPackageButton[i].getAttribute('data-offices')),
			'office': orderItemPackageButton[i].getAttribute('data-office'),
			'lockOffice': orderItemPackageButton[i].getAttribute('data-lock-office'),
			'openModal': orderItemPackageButton[i].getAttribute('data-open-modal'),
		}));
	}

	const reservationExternal = document.querySelectorAll('.component-reservation-external');
	for (let i = 0; i < reservationExternal.length; i++) {
		const el = reservationExternal[i];
		let customFields = [];
		try {
			const cf = el.getAttribute('data-custom-fields');
			if (cf) customFields = JSON.parse(cf);
		} catch (_) {}
		const root = ReactDOM.createRoot(el);
		root.render(React.createElement(ReservationExternal, {
			'itemId': reservationExternal[i].getAttribute('data-item-id'),
			'itemTitle': reservationExternal[i].getAttribute('data-item-title'),
			'locale': reservationExternal[i].getAttribute('data-locale'),
			'seasonId': reservationExternal[i].getAttribute('data-season-id'),
			'offices': JSON.parse(reservationExternal[i].getAttribute('data-offices')),
			'office': reservationExternal[i].getAttribute('data-office'),
			'lockOffice': reservationExternal[i].getAttribute('data-lock-office'),
			'termsUrl': reservationExternal[i].getAttribute('data-terms-url'),
			'gdprUrl': reservationExternal[i].getAttribute('data-gdpr-url'),
			'customFields': customFields,
			'calendarMonths': parseInt(reservationExternal[i].getAttribute('data-calendar-months') || '2', 10),
			'packetaEnabled': reservationExternal[i].getAttribute('data-packeta-enabled') === '1',
			'packetaWidgetApiKey': reservationExternal[i].getAttribute('data-packeta-widget-api-key'),
			'packetaPrice': parseFloat(reservationExternal[i].getAttribute('data-packeta-price') || '0'),
			'packetaCountry': reservationExternal[i].getAttribute('data-packeta-country'),
			'weekendRentalNotice': reservationExternal[i].getAttribute('data-weekend-rental-notice'),
			'addressRequired': reservationExternal[i].getAttribute('data-address-required') === '1',

		}));
	}

    const aiAssistant = document.querySelector('#component-ai-assistant');

    if (aiAssistant) {
        const root = ReactDOM.createRoot(aiAssistant);
        root.render(React.createElement(AiAssistant));
    }

});



